import React from "react";
import { Activity, AlertTriangle } from "lucide-react";

export default function OperationsPulse({ title, subtitle, metrics = [], gap, accent = "var(--gio-primary)" }) {
  return (
    <section 
      className="mb-6 rounded-xl border p-4 md:p-5 shadow-sm" 
      style={{ 
        borderColor: "var(--gio-border)", 
        background: "var(--gio-surface)",
        transition: "all 0.2s ease"
      }} 
      data-testid="operations-pulse"
    >
      <div className="flex items-start gap-3 mb-4">
        <div className="rounded-lg p-2" style={{ color: accent, background: `${accent}18` }}>
          <Activity size={18} />
        </div>
        <div className="min-w-0">
          <h2 className="text-sm font-bold uppercase tracking-wider" style={{ color: "var(--gio-text)" }}>{title}</h2>
          <p className="text-xs mt-1" style={{ color: "var(--gio-muted-2)" }}>{subtitle}</p>
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
        {metrics.map((metric) => (
          <div key={metric.label} className="rounded-lg border p-3 min-w-0" style={{ borderColor: "var(--gio-border)", background: "var(--gio-surface-2)" }}>
            <div className="text-[10px] uppercase tracking-wider truncate" style={{ color: "var(--gio-muted-3)" }}>{metric.label}</div>
            <div className="text-lg font-bold mt-1 truncate" style={{ color: metric.color || "var(--gio-text)" }}>{metric.value}</div>
            {metric.detail && <div className="text-[10px] mt-1 truncate" style={{ color: "var(--gio-muted-2)" }}>{metric.detail}</div>}
          </div>
        ))}
      </div>
      {gap && (
        <div className="mt-3 flex items-start gap-2 text-[11px] leading-relaxed" style={{ color: "var(--gio-muted-2)" }}>
          <AlertTriangle size={13} className="mt-0.5 shrink-0 flex-shrink-0" style={{ color: "#f59e0b" }} />
          <span className="flex-1">{gap}</span>
        </div>
      )}
    </section>
  );
}
